import { Project } from "./entities";

export class QueryProject {
  constructor(params) {
    this.data = this.make(params);
  }

  make(project) {
    return new Project({
      clone: project.attributes.clone,
      master_id: project.attributes.master_id,
      createdAt: project.attributes.created_at,
      updatedAt: project.attributes.updated_at,
      name: project.attributes.name,
      uuid: project.attributes.uuid,
      index: project.index,
      actif: project.attributes.actif,
      owner: {
        ...project.relationships.users.data.attributes,
        id: project.relationships.users.data.id,
      },
      due_date: project.attributes.due_date,
      start_date: project.attributes.start_date,
      priority: project.attributes.priority,
      id: project.id,
      tags: project.relationships.tags.data.map((p) => ({
        id: p.id,
        label: p.attributes.label,
        variant: p.attributes.variant,
      })),
      steps: project.relationships.steps.data.map((p) => ({
        id: p.id,
        ...p.attributes
      })),
      assignees: project.relationships.assignees.data.map(({ attributes, id }) => {

        return {
          id: attributes.userID,
          ID: id,
          email: attributes.email,
          firstName: attributes.first_name,
          phone: attributes.phone,
          lastName: attributes.last_name,
          role: attributes.role,
          isClient: attributes.is_client,
          title: `${attributes.first_name} ${attributes.last_name}`,
          alt: `${attributes.first_name} ${attributes.last_name}`,
          subTitle: attributes.email,
          background: attributes.color,
          locationId: attributes.locationId,

        };
      }),
      slaves: project.relationships.slaves.data.map(({ attributes, id }) => {

        return {
          id,
          ...attributes
        };
      }),

      description: project.attributes.description,
    });
  }

  run() {
    return this.data;
  }
}
